import MarkdownIt from 'markdown-it';

export const markdownRenderer = new MarkdownIt({ breaks: true, html: false, linkify: true });

// Adding renderer rule for link_open
// https://github.com/markdown-it/markdown-it/blob/master/docs/architecture.md#renderer

const mdLinkRule = markdownRenderer.renderer.rules.link_open;
const proxyToDefault = (tokens, idx, options, env, self) => self.renderToken(tokens, idx, options); // eslint-disable-line max-params

// Remember old renderer, if overridden, or proxy to default renderer
const defaultRender = mdLinkRule || proxyToDefault;

// eslint-disable-next-line max-params
markdownRenderer.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  // If you are sure other plugins can't add `target` - drop check below
  const aTagIndex = tokens[idx].attrIndex('target');

  if (aTagIndex < 0) {
    tokens[idx].attrPush(['target', '_blank']); // add new attribute
    tokens[idx].attrPush(['rel', 'noopener noreferrer']);
  } else {
    // eslint-disable-next-line no-param-reassign
    tokens[idx].attrs[aTagIndex][1] = '_blank'; // replace value of existing attr
  }

  // pass token to default renderer.
  return defaultRender(tokens, idx, options, env, self);
};
